import { html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { booleanConverter } from './common/converters';
import { TeComponent } from './common/te-component';
import { theme } from './common/theme';
import { TeTabs } from './te-tabs';
import './te-text';

export const tabOptionStyles = [
  ...TeComponent.styles,
  css`
    .te-tabs-option-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 16px;
      height: 40px;
      cursor: pointer;
      min-width: fit-content;
      width: 100%;
      margin: 0px;
      border: none;
      background: transparent;
      z-index: 1;
      white-space: nowrap;
      overflow: hidden;
    }

    .te-tabs-option-wrapper.disabled {
      color: ${theme.colors.shade3};
      pointer-events: none;
    }
  `,
];

/** Tab Component */
@customElement('te-tab')
export class TeTab extends TeComponent {
  static get styles() {
    return [...tabOptionStyles];
  }

  /** Tab is active / selected */
  @property({ type: Boolean, converter: booleanConverter }) active = false;
  /** Tab is disabled */
  @property({ type: Boolean, reflect: true }) disabled = false;
  /** Text value for tab */
  @property({ type: String }) text = '';
  @state() private _parentNode = this.parentNode as TeTabs;

  handleTextClick(e: Event) {
    if (this.disabled) return;
    this.handleClick(e);
  }

  updated() {
    if (this._parentNode.variant === 'underlined') {
      this._parentNode.requestUpdate();
    }
  }

  render() {
    const classes = [
      'te-tabs-option-wrapper',
      this.active ? 'active' : '',
      this.disabled ? 'disabled' : '',
    ].filter(Boolean);

    const color = this.active
      ? theme.colors.primary.v0.toString()
      : this.disabled
      ? theme.colors.shade3.toString()
      : theme.colors.text.toString();

    return html`
      <style>
        .te-tabs-option-wrapper.active {
          color: ${theme.colors.primary.v0};
          background: ${this._parentNode.variant === 'underlined' ? '' : 'white'};
        }
      </style>
      <button class="${classes.join(' ')}" @click=${this.handleTextClick}>
        <te-text size="14" weight="500" color=${color}>
          ${this.text}
        </te-text>
      </button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'te-tab': TeTab;
  }
}
